import React from 'react';

const Audit = (props) =>
  <svg className={props.class} xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="56.967" height="73" viewBox="0 0 56.967 73">
  <defs>
    <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
      <stop offset="0.158" stopColor="#f6760d"/>
      <stop offset="1" stopColor="#fd9400"/>
    </linearGradient>
  </defs>
  <g id="Group_2920" data-name="Group 2920" transform="translate(-4902.01 -7782.145)">
    <path id="Path_691" data-name="Path 691" d="M4943.578,7799.959c.534,0,1.157-.357,1.157-.8v-5.429h7.655a4.894,4.894,0,0,1,4.807,4.538v51c0,2.493-2.315,4.094-4.807,4.094H4908.6c-2.492,0-4.807-1.6-4.807-4.094v-51a4.894,4.894,0,0,1,4.807-4.538h7.655v5.429c0,.444.534.8,1.067.8Zm-25.546-10.681h5.785a1.071,1.071,0,0,0,.891-.89,5.786,5.786,0,0,1,11.393,0,1.071,1.071,0,0,0,.89.89h5.964v8.9h-24.923Zm12.373-7.122a7.3,7.3,0,0,0-7.3,5.342h-5.787c-.533,0-1.067,0-1.067.532v3.918H4908.6a6.676,6.676,0,0,0-6.587,6.319v51c0,3.472,3.115,5.875,6.587,5.875h43.793c3.471,0,6.587-2.4,6.587-5.875v-51a6.674,6.674,0,0,0-6.587-6.319h-7.655v-3.918c0-.532-.623-.532-1.157-.532H4937.7a7.123,7.123,0,0,0-6.9-5.353c-.134,0-.269,0-.4.011" fill="url(#linear-gradient)"/>
  </g>
</svg>
;

export default Audit;